<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/idts">Interdepartmental Transfers</b-breadcrumb-item>
            <b-breadcrumb-item active>{{ currentTab }} IDTs</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="card-header">
                <ul class="card-header-tabs nav nav-tabs">
                    <li class="nav-item">
                        <a @click="switchTabs('Network')" class="active nav-link"
                            data-toggle="tab"
                            href="#">Network</a>
                    </li>
                    <li class="nav-item">
                        <a @click="switchTabs('Lease')" class="nav-link"
                            data-toggle="tab"
                            href="#">Lease</a>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <AppNotification type="info" v-if="currentIDTNumber">
                  Current {{ currentTab }} IDT Number is {{currentIDTNumber}}
                </AppNotification>
                <AppNotification type="info" v-else>
                  IDT Number is currently not set.
                </AppNotification>

                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                      <div class="form-row">
                        <div class="col-md-4 col-sm-6 form-group">
                          <label for="sl">SL</label>
                          <input
                            class="form-control"
                            placeholder="SL Number"
                            v-model="filterOptions.sl"
                          />
                        </div>
                        <div class="col-md-4 col-sm-6 form-group">
                          <label for="sa">SA</label>
                          <input
                            class="form-control"
                            placeholder="SA Number"
                            v-model="filterOptions.sa"
                          />
                        </div>
                        <div class="col-md-4 col-sm-6 form-group">
                          <label for="organizationCode">Department Code</label>
                          <input
                            class="form-control"
                            placeholder="Department Code"
                            v-model="filterOptions.organizationCode"
                          />
                        </div>
                        <div class="col-md-4 col-sm-6 form-group align-self-center">
                            <AppCheckBox v-model="filterOptions.onlyShowDataIssues">
                                Only Show Data with Issues
                            </AppCheckBox>
                        </div>
                      </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>

                <div class="card">
                    <div class="bg-dark card-header text-white">
                        <div class="row">
                          <div class="col text-start">{{ currentTab }} IDTs</div>
                          <div class="col" style="text-align: right;">Total: {{ totalAmountCharged | currency }}</div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="d-print-none dropdown mb-3 text-right">
                            <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                                    data-toggle="dropdown" style="width: 100px" type="button">
                                <span>Actions</span>
                            </button>
                            <div class="dropdown-menu">
                                <RouterLink
                                  :to="{ name: 'AddIDT', params: { type: currentTab, fiscalPeriodIDTNumberId: idtNumberId } }"
                                  class="btn btn-outline-light dropdown-item text-left"
                                  title="Add New IDT"
                                >
                                  <i class="fa fa-plus"></i>Add
                                </RouterLink>
                                <button class="btn btn-outline-light dropdown-item text-left" @click="isUpdateModalVisible=true">
                                  <i class="fa fa-plus"></i> Update IDT Number
                                </button>
                                <a @click.prevent="downloadIDTFrozenAndMissingAccounts()" class="btn btn-outline-light dropdown-item text-left"
                                  href="javascript:void(0)" title="Export missing and frozen IDT account list to a CSV">
                                    <i class="fa fa-file-excel"></i>Download Missing and Frozen Accounts .csv
                                </a>
                            </div>
                        </div>
                        <BTable :busy="isLoading"
                                :fields="tableFields"
                                :items="idts"
                                :responsive="true"
                                primary-key="id"
                                show-empty
                                striped
                                table-class="table-align-middle">

                            <template v-slot:cell(id)="row">
                                <div class="btn-group">
                                    <router-link
                                            :to="{ name:'EditIDT', params:{ id: row.item.id, type: currentTab, accountId: row.item.accountId, organizationId: row.item.organizationId, sl: row.item.sl, sa: row.item.sa, organizationCode: row.item.organizationCode, accountIsActive: row.item.accountIsActive, accountIsFrozen: row.item.accountIsFrozen, organizationIsActive: row.item.organizationIsActive, amountCharged: row.item.amountCharged, description: row.item.description } }"
                                            class="btn btn-sm btn-warning d-print-none"
                                            data-toggle="tooltip"
                                            title="Edit IDT">
                                        <i class="fa fa-pencil-alt"></i>Edit
                                    </router-link>
                                </div>
                            </template>

                            <template v-slot:cell(sl)="row">
                              <i v-if="row.item.accountId == null || (row.item.accountIsActive != null && !row.item.accountIsActive) || (row.item.accountIsFrozen != null && row.item.accountIsFrozen) || row.item.organizationId == null || row.item.organizationCode == null || (row.item.organizationIsActive != null && !row.item.organizationIsActive)" class="fa fa-exclamation-circle" style="color: red !important;display:inline;padding-right:5px;"></i>
                              {{ row.item.sl }}
                            </template>

                            <template v-slot:cell(amountCharged)="row">
                              {{ row.item.amountCharged | currency(true) }}
                            </template>

                            <!-- Footer Pagination -->
                            <template v-slot:custom-foot>
                                <b-tr>
                                    <b-td :colspan="tableFields.length">
                                        <AppTablePagination
                                                :page.sync="filterOptions.page"
                                                :pageSize.sync="filterOptions.pageSize"
                                                :totalCount.sync="totalIDTs"
                                                v-on:update:page="loadData()"
                                                v-on:update:pageSize="loadData()"
                                        ></AppTablePagination>
                                    </b-td>
                                </b-tr>
                            </template>
                        </BTable>
                    </div>
                </div>
            </div>
        </div>
        <TheIDTNumberUpdateForm 
          :visible="isUpdateModalVisible" 
          :currentIDTNumber="currentIDTNumber"
          :idtNumberId="idtNumberId"
          @close="isUpdateModalVisible=false; loadData();" />
    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import InterdepartmentalTransfersService from "@/services/InterdepartmentalTransfersService";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import {currency} from "@/filters/Currency";
    import AppCheckBox from '@/components/shared/AppCheckBox.vue';
    import AppNotification from '@/components/shared/AppNotification.vue'
    import TheIDTNumberUpdateForm from './TheIDTNumberUpdateForm.vue'

    export default {
        components: {
            AppTablePagination,
            AppFormCardCollapsable,
            AppCheckBox,
            AppNotification,
            TheIDTNumberUpdateForm
        },
        filters: {
            currency
        },
        data() {
            return {
                currentTab: 'Network',
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    sl: null,
                    sa: null,
                    organizationCode: null,
                    onlyShowDataIssues: false
                },
                isLoading: false,
                isPerformingAction: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:150px'
                    }, 
                    {
                        key: 'sl',
                        label: 'SL'
                    },
                    {
                        key: 'sa',
                        label: 'SA'
                    },
                    {
                        key: 'organizationCode',
                        label: 'Department'
                    },
                    {
                        key: 'amountCharged',
                        label: 'Amount Charged'
                    },
                    {
                        key: 'accountStatus',
                        label: "Account Status"
                    }
                ],
                idts: [],
                totalIDTs: 0,
                totalAmountCharged: 0,
                currentIDTNumber: null,
                idtNumberId: null,
                isUpdateModalVisible: false
            }
        },
        methods: {
            loadData() {
              const vm = this;
              this.isLoading = true;

              InterdepartmentalTransfersService.getIDTs(this.currentTab, this.filterOptions)
                .then((responseOne) => {
                  vm.idts = responseOne.data.map((t) => {
                    return { ...t, accountStatus: t.accountId == null ? "Missing from BIMS data" : !t.accountIsActive ? "Inactive" : t.accountIsFrozen ? "Frozen" : "Good"}
                  });
                  vm.totalIDTs = responseOne.totalCount;

                  if (responseOne.data.length > 0) {
                    InterdepartmentalTransfersService.getIDTNumber(responseOne.data[0].fiscalPeriodIDTNumberId)
                      .then((responseTwo) => {
                        vm.totalAmountCharged = responseTwo.totalAmountCharged;
                        vm.currentIDTNumber = responseTwo.number;
                        vm.idtNumberId = responseTwo.id;
                      })
                      .catch(() => {
                        vm.redirectToError();
                      })
                      .finally(() => {
                        vm.isLoading = false;
                      });
                  }
                  else {
                    vm.isLoading = false;
                  }
                })
                .catch(() => {
                  vm.redirectToError();
                });
            },
            
            onFilterSubmit() {
              this.filterOptions.page = 1;
              this.loadData();
            },

            switchTabs(type) {
              this.filterOptions.pageSize = 10;
              this.filterOptions.sl = null;
              this.filterOptions.sa = null;
              this.filterOptions.organizationCode = null;
              this.currentTab = type;

              this.onFilterSubmit();
            },

            /**
             * @description Downloads the frozen and missing accounts list for idts CSV export to the user's browser
             */
            downloadIDTFrozenAndMissingAccounts() {
                this.isPerformingAction = true;
                const vm = this;

                InterdepartmentalTransfersService.downloadIDTFrozenAndMissingAccounts(this.currentTab)
                    .catch(() => {
                        vm.alert(ToastType.Danger, "Unable to generate report. Please contact NIS if the issue persists.")
                    })
                    .finally(() => {
                        this.isPerformingAction = false
                    });
            }
        },
        created() {
            this.loadData();
        }
    }
</script>
